import {
  Apps20Filled,
  Apps20Regular,
  Apps24Filled,
  Apps24Regular,
  type FluentIconsProps,
} from "@fluentui/react-icons";
import React from "react";
export type IconSize = "default" | "wide";
export interface AppBarIconProps {
  size: IconSize;
}

export { ArrowRight20Filled as LinkIcon } from "@fluentui/react-icons";

export const AppsIcon = (
  props: FluentIconsProps & AppBarIconProps
): React.ReactElement | null => {
  return props.size === "default" ? (
    <Apps20Regular {...props} />
  ) : (
    <Apps24Regular {...props} />
  );
};
export const AppsIconSelected = (
  props: FluentIconsProps & AppBarIconProps
): React.ReactElement | null => {
  return props.size === "default" ? (
    <Apps20Filled {...props} />
  ) : (
    <Apps24Filled {...props} />
  );
};
